export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
          联系投稿
        </h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
          欢迎漫画作者、汉化组及合作方与我们联系。如有资源投稿、商务合作或问题反馈，
          请通过以下方式与51漫画网团队取得联系，我们将在第一时间回复您。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
          <div className="flex items-center gap-3 px-6 py-4 bg-background-100 rounded-xl">
            <div className="w-10 h-10 flex items-center justify-center">
              <i className="ri-mail-line text-xl text-primary-600"></i>
            </div>
            <div className="text-left">
              <div className="text-xs text-foreground-500">投稿邮箱</div>
              <div className="text-sm font-medium text-foreground-800">submit@51manhua.com</div>
            </div>
          </div>
          <div className="flex items-center gap-3 px-6 py-4 bg-background-100 rounded-xl">
            <div className="w-10 h-10 flex items-center justify-center">
              <i className="ri-customer-service-2-line text-xl text-primary-600"></i>
            </div>
            <div className="text-left">
              <div className="text-xs text-foreground-500">商务合作</div>
              <div className="text-sm font-medium text-foreground-800">biz@51manhua.com</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}